<pbc-filter [config]="RechnungsVorlagenFilterConfig" [filter]="rechnungsVorlagen.filter$ | async" (filterChange)="rechnungsVorlagen.filter$.next($event)"></pbc-filter>
